import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';

export const ROUTES_TITLES = [
  // Analytics
  {
    title: 'nav.analytics.live-vessel',
    url: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.LIVE_VESSEL}`
  },
  {
    title: 'nav.analytics.live-terminal',
    url: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.LIVE_TERMINAL}`
  },
  {
    title: 'analytics.daily_bunker_price',
    url: `/${ROUTE_NAMES.ANALYTICS}/${ROUTE_NAMES.BUNKER_ANALYSIS}/${ROUTE_NAMES.DAILY_BUNKER_PRICE}`
  },
  {
    title: 'nav.port-expense.agent-soa',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.SOA}`
  },
  {
    title: 'billing.exchange_rate',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.EXCHANGE_RATE}`
  },
  {
    title: 'billing.floating_account',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.FLOATING_ACCOUNT}`
  },
  // Database
  {
    title: 'nav.database.company',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.COMPANY}`
  },
  {
    title: 'nav.database.user',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.USER}`
  },
  {
    title: 'nav.database.vessel-group',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.VESSEL}/${ROUTE_NAMES.VESSEL}`
  },
  {
    title: 'nav.database.my-fleet',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.VESSEL}/${ROUTE_NAMES.MY_FLEET}`
  },
  {
    title: 'database.vessel_pic',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.VESSEL}/${ROUTE_NAMES.VESSEL_PIC}`
  },
  {
    title: 'database.vessel_issues_translations.vessel_issues',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.VESSEL}/${ROUTE_NAMES.VESSEL_ISSUES}`
  },
  {
    title: 'nav.database.cargo',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.CARGO}`
  },
  {
    title: 'nav.database.port',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.PORT}`
  },
  {
    title: 'nav.database.location',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.LOCATION}`
  },
  {
    title: 'nav.database.department',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.DEPARTMENT}`
  },
  {
    title: 'nav.database.bank',
    url: `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.BANK}`
  },
  // Port Expense (DA Management)
  {
    title: 'port_expense.da_comparison',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}/${ROUTE_NAMES.COMPARISON}`
  },
  {
    title: 'port_expense.epda_submitted_by_agent',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}/${ROUTE_NAMES.SUBMISSION}`
  },
  {
    title: 'port_expense.da_elxa',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}/${ROUTE_NAMES.TC}`
  },
  {
    title: 'port_expense.da_by_vessel',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}/${ROUTE_NAMES.VESSEL}`
  },
  {
    title: 'port_expense.fda_country_name',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.DA_MANAGEMENT}/${ROUTE_NAMES.REPORTING}`
  },
  // Port Expense (Owner's Account)
  {
    title: 'port_expense.fda_oa_check',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.OWNERS_ACCOUNT}/${ROUTE_NAMES.FDA_OA_CHECK}`
  },
  {
    title: 'port_expense.oa_list',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.OWNERS_ACCOUNT}/${ROUTE_NAMES.OA_LIST}`
  },
  {
    title: 'port_expense.oa_grouped',
    url: `/${ROUTE_NAMES.PORT_EXPENSE}/${ROUTE_NAMES.OWNERS_ACCOUNT}/${ROUTE_NAMES.OA_GROUPED}`
  },
  // Port Operations (Cash To Master)
  {
    title: 'port_operation.ctm_requests',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.CTM}/${ROUTE_NAMES.REQUESTS}`
  },
  {
    title: 'port_operation.ctm_orders',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.CTM}/${ROUTE_NAMES.ORDERS}`
  },
  {
    title: 'port_operation.ctm_invoices',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.CTM}/${ROUTE_NAMES.INVOICES}`
  },
  // Port Operations (Port Call)
  {
    title: 'port_operation.current',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.PORTCALL}/${ROUTE_NAMES.STATUS}/${ROUTE_NAMES.CURRENT}`
  },
  {
    title: 'port_operation.complete',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.PORTCALL}/${ROUTE_NAMES.STATUS}/${ROUTE_NAMES.COMPLETE}`
  },
  {
    title: 'port_operation.calendar',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.PORTCALL}/${ROUTE_NAMES.CALENDAR}/${ROUTE_NAMES.MONTH}`
  },
  // Port Operations (Demurrage)
  {
    title: 'port_operation.demurrage',
    url: `/${ROUTE_NAMES.PORT_OPERATION}/${ROUTE_NAMES.TERMINAL_DEMURRAGE}`
  },

  // Chartering and Operations (Vessel Schedule)
  {
    title: 'chartering.itinerary',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_SCHEDULE}/${ROUTE_NAMES.ITINERARY}`
  },
  {
    title: 'chartering.vessel_schedule_translations.gantt_chart',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_SCHEDULE}/${ROUTE_NAMES.GANTT_CHART}`
  },
  // Chartering and Operations (Voyage Charter)
  {
    title: 'chartering.voyage-charter_translations.charter_party',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VOYAGE_CHARTER}/${ROUTE_NAMES.CHARTER_PARTY}`
  },
  {
    title: 'chartering.voyage_charter_translations.voyage_management',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VOYAGE_CHARTER}/${ROUTE_NAMES.VOYAGE_MANAGEMENT}`
  },
  {
    title: 'chartering.voyage_charter_translations.voyage_calculator',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VOYAGE_CHARTER}/${ROUTE_NAMES.VOYAGE_CALCULATOR}`
  },
  {
    title: 'chartering.demurrage_claims',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VOYAGE_CHARTER}/${ROUTE_NAMES.DEMURRAGE_CLAIM}`
  },
  // Chartering and Operations (VC Invoices)
  {
    title: 'chartering.vc_invoices_translations.vc_freight_invoices',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VC_INVOICES}/${ROUTE_NAMES.FREIGHT_INVOICES}`
  },
  {
    title: 'chartering.vc_invoices_translations.vc_demurrage_invoices',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VC_INVOICES}/${ROUTE_NAMES.DEMURRAGE_INVOICES}`
  },
  {
    title: 'chartering.vc_invoices_translations.vc_brokerage_invoices',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VC_INVOICES}/${ROUTE_NAMES.BROKERAGE_INVOICES}`
  },
  // Chartering and Operations (Time Charter)
  {
    title: 'chartering.time_charter_translations.time_charter',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TIME_CHARTER}/${ROUTE_NAMES.TIME_CHARTER}`
  },
  {
    title: 'chartering.time_charter_translations.bare_boat_charter',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TIME_CHARTER}/${ROUTE_NAMES.BARE_BOAT_CHARTER}`
  },
  {
    title: 'chartering.voyage',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TIME_CHARTER}/${ROUTE_NAMES.VOYAGE}`
  },
  // Chartering and Operations (TC Invoices)
  {
    title: 'chartering.tc_invoices_translations.tc_hire_invoices',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TC_INVOICES}/${ROUTE_NAMES.HIRE_INVOICES}`
  },
  {
    title: 'chartering.tc_invoices_translations.tc_brokerage_invoices',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.TC_INVOICES}/${ROUTE_NAMES.BROKERAGE_INVOICES}`
  },
  // Chartering and Operations (Vessel Reports)
  {
    title: 'chartering.noon_report',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_REPORT_CHARTERING}/${ROUTE_NAMES.NOON}`
  },
  {
    title: 'chartering.port_report',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_REPORT_CHARTERING}/${ROUTE_NAMES.PORT}`
  },
  {
    title: 'chartering.vessel_reports_translations.monthly_rob_report',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_REPORT_CHARTERING}/${ROUTE_NAMES.MONTHLY_ROB}`
  },
  {
    title: 'chartering.vessel_reports_translations.timesheet',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.VESSEL_REPORT_CHARTERING}/${ROUTE_NAMES.TIMESHEET}`
  },
  // Chartering and Operations (Inventory Supply)
  {
    title: 'chartering.inventory_supply',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.INVENTORY_SUPPLY}`
  },
  // Chartering and Operations (Bunker Supply)
  {
    title: 'chartering.bunker_supply_request',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.BUNKER_SUPPLY}/${ROUTE_NAMES.REQUEST}`
  },
  {
    title: 'chartering.bunker_supply_comparison',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.BUNKER_SUPPLY}/${ROUTE_NAMES.COMPARISON}`
  },
  {
    title: 'chartering.bunker_orders',
    url: `/${ROUTE_NAMES.CHARTERING}/${ROUTE_NAMES.BUNKER_SUPPLY}/${ROUTE_NAMES.ORDER}`
  },

  // Ship Shore Operation (Vessel Call)
  {
    title: 'ship_shore_operation.on_going',
    url: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.VESSEL_CALL}/${ROUTE_NAMES.STATUS}/${ROUTE_NAMES.ON_GOING}`
  },
  {
    title: 'ship_shore_operation.departed',
    url: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.VESSEL_CALL}/${ROUTE_NAMES.STATUS}/${ROUTE_NAMES.DEPARTED}`
  },
  {
    title: 'ship_shore_operation.calendar',
    url: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.VESSEL_CALL}/${ROUTE_NAMES.CALENDAR}/${ROUTE_NAMES.MONTH}`
  },
  // Ship Shore Operation (Pre Arrival Notice)
  {
    title: 'ship_shore_operation.pre_arrival_notice',
    url: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.PRE_ARRIVAL_NOTICE}`
  },
  // Ship Shore Operation (Pre-Berth Questionnaire)
  {
    title: 'ship_shore_operation.pre_berth_questionnaire',
    url: `/${ROUTE_NAMES.SHIP_SHORE_OPERATION}/${ROUTE_NAMES.PRE_BERTH_QUESTIONNAIRE}`
  },

  // Ship Interface (Itinerary)
  {
    title: 'ship_interface.itinerary',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.ITINERARY}/${ROUTE_NAMES.ITINERARY}`
  },
  {
    title: 'chartering.vessel_schedule_translations.gantt_chart',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.ITINERARY}/${ROUTE_NAMES.GANTT_CHART}`
  },
  // Ship Interface (Vessel Reports)
  {
    title: 'ship_interface.noon_reports',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.NOON}`
  },
  {
    title: 'ship_interface.port_reports',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.PORT}`
  },
  {
    title: 'ship_interface.monthly_rob_report',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.VESSEL_REPORT_SHIP_INTERFACE}/${ROUTE_NAMES.MONTHLY_ROB}`
  },
  // Ship Interface (Timesheet)
  {
    title: 'ship_interface.timesheet',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.TIMESHEET}`
  },
  // Ship Interface (Requisitions)
  {
    title: 'ship_interface.bunker_request',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.REQUISITIONS}/${ROUTE_NAMES.BUNKER_REQUEST}`
  },
  {
    title: 'ship_interface.cash_to_master_request',
    url: `/${ROUTE_NAMES.SHIP_INTERFACE}/${ROUTE_NAMES.REQUISITIONS}/${ROUTE_NAMES.CTM_REQUEST}`
  },

  // Billing (Approval Board)
  {
    title: 'billing.approval_board',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.APPROVAL_BOARD_OWNER}`
  },
  // Billing (ELXA Approval)
  {
    title: 'billing.elxa_approval',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.APPROVAL_BOARD_ELXA}`
  },
  // Billing (Invoice Management)
  {
    title: 'billing.ar_ap',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.AR_AP}`
  },
  {
    title: 'billing.account_receivable',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.RECEIVABLE}`
  },
  {
    title: 'billing.account_payable',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.PAYABLE}`
  },
  {
    title: 'billing.claim_receivable',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.CLAIM}`
  },
  {
    title: 'billing.manual_invoice',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.MANUAL}`
  },
  {
    title: 'billing.paid_invoice',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.INVOICE_MANAGEMENT}/${ROUTE_NAMES.PAID}`
  },
  // Billing (ELXA Invoices)
  {
    title: 'billing.elxa_invoice_translations.grid.replenish',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.ELXA_INVOICES}/${ROUTE_NAMES.REPLENISH}`
  },
  {
    title: 'billing.elxa_invoice_translations.grid.saas',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.ELXA_INVOICES}/${ROUTE_NAMES.SAAS}`
  },
  {
    title: 'billing.elxa_invoice_translations.grid.port_service',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.ELXA_INVOICES}/${ROUTE_NAMES.PORT_SERVICE}`
  },
  // Billing (Payments)
  {
    title: 'billing.approval-board_translations.account_payable',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.PROCESSED_PAYMENTS}/${ROUTE_NAMES.PAYABLE}`
  },
  {
    title: 'billing.approval-board_translations.account_receivable',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.PROCESSED_PAYMENTS}/${ROUTE_NAMES.RECEIVABLE}`
  },
  {
    title: 'billing.completed_payments',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.PROCESSED_PAYMENTS}/${ROUTE_NAMES.COMPLETED_PAYMENTS}`
  },
  // Billing (Credit Balance)
  {
    title: 'billing.credit-balance_translations.credit-balance',
    url: `/${ROUTE_NAMES.BILLING}/${ROUTE_NAMES.CREDIT_BALANCE}`
  },

  // ELXA Controls (CTM Tariff)
  {
    title: 'elxa_controls.ctm_tariff_translations.titles.view',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.CTM_CONTROLS}`
  },
  // ELXA Controls (Port Expense Controls)
  {
    title: 'elxa_controls.da_tariff_translations.grid.da_tariff',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.PORT_EXPENSE_CONTROLS}/${ROUTE_NAMES.DA_TARIFF}`
  },
  {
    title: 'elxa_controls.default_port_expense_translations.grid.default_port_expense',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.PORT_EXPENSE_CONTROLS}/${ROUTE_NAMES.DEFAULT_PORT_EXPENSE}`
  },
  // ELXA Controls (PBQ Form)
  {
    title: 'elxa_controls.pbq_form',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.PRE_BERTH_QUESTIONNAIRE_FORM}`
  },
  // ELXA Controls (Xero Controls)
  {
    title: 'elxa_controls.xero_contacts_translations.grid.xero_contacts',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.XERO_CONTROLS}/${ROUTE_NAMES.XERO_CONTACTS}`
  },
  {
    title: 'elxa_controls.xero_accounts_translations.grid.xero_accounts',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.XERO_CONTROLS}/${ROUTE_NAMES.XERO_ACCOUNTS}`
  },
  // ELXA Controls (Subscriptions)
  {
    title: 'nav.elxa-controls.subscriptions',
    url: `/${ROUTE_NAMES.ELXA_CONTROLS}/${ROUTE_NAMES.SUBSCRIPTIONS}`
  }
];
